import { render, staticRenderFns } from "./ZhanhuiTopDwBlock.vue?vue&type=template&id=23df2488&scoped=true"
import script from "./ZhanhuiTopDwBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiTopDwBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df2488",
  null
  
)

export default component.exports